export const BalanceManagerEvents = {
  GetBalance: 'BalanceManager.GetBalance',
  BalanceReturned: 'BalanceManager.BalanceReturned',

  GetPricePerSecond: 'BalanceManager.GetPricePerSecond',
  PricePerSecondReturned: 'BalanceManager.PricePerSecondReturned',

  GetLastUpdateTime: 'BalanceManager.GetLastUpdateTime',
  LastUpdateTimeReturned: 'BalanceManager.LastUpdateTimeReturned',

  Deposit: 'BalanceManager.Deposit',
  DepositCompleted: 'BalanceManager.DepositCompleted',

  Withdraw: 'BalanceManager.Withdraw',
  WithdrawCompleted: 'BalanceManager.WithdrawCompleted',
}
